import { ServerStack01Icon } from "@hugeicons/core-free-icons";
import type { IconSvgElement } from "@hugeicons/react";
import { Bubble, GlowCard } from "@/ui/components/glow-card";

export function TabEmpty({ title, children, icon = ServerStack01Icon }: { title: string; children?: React.ReactNode; icon?: IconSvgElement }) {
  return (
    <GlowCard className="bg-muted/60">
      <div className="flex flex-col items-center justify-center gap-1.5 py-8 text-center">
        <Bubble icon={icon} className="mb-2" />
        <span className="text-sm font-semibold">{title}</span>
        {children ? <span className="max-w-64 text-[13px] text-muted-foreground">{children}</span> : null}
      </div>
    </GlowCard>
  );
}
